import React from "react";
import Navbar from "./Navbar";
import "../component/css/Home.css";

export default function Home() {
  return (
    <div>
      <Navbar />
    </div>
  );
}
